module.exports = __webpack_public_path__ + "static/media/Product Disclosure Statement - VFSC.df057e2b.pdf";